// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"4e332f95","275":"7fdc6469","453":"87870af1","781":"4bdf35fc","981":"4434f11b"}[chunkId] + ".chunk.js";
};